import { FC } from 'react';

import { Stack, Typography } from '@mui/material';

import { AccessTimeIcon, CloseIcon, SuccessIcon } from 'shared/assets/icons';
import { TStatusType } from 'shared/services/types/common.types';

interface IProps {
  status: TStatusType | null;
}

const statusMap: Record<TStatusType, { icon: React.ReactElement; text: string; color?: string }> = {
  done: { icon: <SuccessIcon />, text: 'Ready' },
  in_progress: { icon: <AccessTimeIcon />, text: 'Waiting' },
  received: { icon: <AccessTimeIcon />, text: 'Waiting' },
  declined: { icon: <CloseIcon color='var(--mui-palette-error-main)' />, text: 'Cancel' },
  scam: { icon: <AccessTimeIcon />, text: 'Waiting' },
  manual: { icon: <AccessTimeIcon />, text: 'Waiting' }
};

export const Status: FC<IProps> = ({ status }) => {
  const { icon, text } = statusMap?.[status!] || {};

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      sx={[
        {
          borderRadius: 2,
          width: '18px',
          height: '18px',
          padding: '7.5px',
          margin: '0 auto',
          fontWeight: '500',
          boxSizing: 'initial',
          '.MuiTypography-root': { display: 'none' },
          '&svg': { width: '100%', height: '100%' }
        },
        status === 'done' && {
          backgroundColor: 'var(--mui-palette-status-activeBackground)',
          color: 'var(--mui-palette-status-activeColor)'
        },
        (status === 'in_progress' || status === 'received') && {
          backgroundColor: 'var(--mui-palette-status-pendingBackground)',
          color: 'var(--mui-palette-status-pendingColor)'
        },
        status === 'declined' && {
          backgroundColor: 'var(--mui-palette-status-declinedBackground)',
          color: 'var(--mui-palette-status-declinedColor)',
          justifyContent: 'center'
        }
      ]}>
      {icon}
      <Typography>{text}</Typography>
    </Stack>
  );
};
